import { Chip } from '@mui/material'

const variantStyles = {
	active: {
		backgroundColor: '#EDF7EE',
		borderRadius: '4px',
		height: '24px',
		padding: '4px 10px',
		'& .MuiChip-icon': {
			width: '4px !important',
			height: '4px !important',
			color: '#4CAF50',
			margin: '0 4px 0 0 !important',
		},
		'& .MuiChip-label': {
			fontSize: '12px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#4CAF50',
			padding: '0',
			textTransform: 'capitalize',
		},
	},
	closed: {
		backgroundColor: '#FEF3F2',
		borderRadius: '4px',
		height: '24px',
		padding: '4px 10px',
		'& .MuiChip-icon': {
			width: '4px !important',
			height: '4px !important',
			color: '#D92D20',
			margin: '0 4px 0 0 !important',
		},
		'& .MuiChip-label': {
			fontSize: '12px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#D92D20',
			padding: '0',
			textTransform: 'capitalize',
		},
	},
	pending: {
		backgroundColor: '#FFF5E9',
		borderRadius: '4px',
		height: '24px',
		padding: '4px 10px',
		'& .MuiChip-icon': {
			width: '4px !important',
			height: '4px !important',
			color: '#FF9B21',
			margin: '0 4px 0 0 !important',
		},
		'& .MuiChip-label': {
			fontSize: '12px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#FF9B21',
			padding: '0',
			textTransform: 'capitalize',
		},
	},
	inprogress: {
		backgroundColor: '#F2F6F8',
		borderRadius: '4px',
		height: '24px',
		padding: '4px 10px',
		'& .MuiChip-icon': {
			width: '4px !important',
			height: '4px !important',
			color: '#7CA6BD',
			margin: '0 4px 0 0 !important',
		},
		'& .MuiChip-label': {
			fontSize: '12px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#7CA6BD',
			padding: '0',
			textTransform: 'capitalize',
		},
	},
	submitted: {
		backgroundColor: '#F2F6F8',
		borderRadius: '8px',
		height: '36px',
		padding: '4px 10px',
		'& .MuiChip-icon': {
			width: '4px !important',
			height: '4px !important',
			color: '#7CA6BD',
			margin: '0 4px 0 0 !important',
		},
		'& .MuiChip-label': {
			fontSize: '12px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#7CA6BD',
			padding: '0',
			textTransform: 'capitalize',
		},
	},
	error: {
		backgroundColor: '#FEECEB',
		borderRadius: '4px',
		height: '24px',
		padding: '4px 10px',
		'& .MuiChip-icon': {
			width: '4px !important',
			height: '4px !important',
			color: '#F44336',
			margin: '0 4px 0 0 !important',
		},
		'& .MuiChip-label': {
			fontSize: '12px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#F44336',
			padding: '0',
			textTransform: 'capitalize',
		},
	},
	revision: {
		backgroundColor: '#F5EBF8',
		borderRadius: '4px',
		height: '24px',
		padding: '4px 10px',
		'& .MuiChip-icon': {
			width: '4px !important',
			height: '4px !important',
			color: '#9B38BD',
			margin: '0 4px 0 0 !important',
		},
		'& .MuiChip-label': {
			fontSize: '12px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#9B38BD',
			padding: '0',
			textTransform: 'capitalize',
		},
	},
}

const getStatusVariant = (status) => {
  switch (status?.toLowerCase()) {
    case 'booked':
      return 'active';
    case 'upcoming':
      return 'inprogress';
    case 'closed':
      return 'closed';
    case 'new':
      return 'pending';
    default:
      return 'default';
  }
};

const StatusBtn = ({ label, variant = 'active', ...rest }) => {
	const styles = variantStyles[variant] || variantStyles.active

	return (
		<Chip
			icon={
				<span
					style={{
						display: 'inline-block',
						borderRadius: '50%',
						backgroundColor: 'currentColor',
						width: 8,
						height: 8,
					}}
				/>
			}
			label={label}
			sx={styles}
			{...rest}
		/>
	)
}

export default StatusBtn
